/// <reference types="vite/client" />

export const env = {
    apiUrlBase: import.meta.env.VITE_BOOKING_SERVER,
};